module.exports = __webpack_public_path__ + "cable.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/cable.mp3
// module id = 666
// module chunks = 0